import {AppLayout} from "../component/app-layout";
import React, {useMemo} from "react";
import {BookingContextProvider, useBooking} from "../context/booking";
import {useParams} from "react-router-dom";
import {BookingPayment} from "./booking/booking-payment";
import {BookingDetails} from "./booking/booking-details";
import {isBlank} from "../utils";
import {BookingBoxes} from "./booking/booking-boxes";
import {hasSimplifiedLayout} from "../booking-utils";
import {BookingDetailsSimplified} from "./booking/simplified/booking-details-simplified";
import {BookingProlongation} from "./booking/booking-prolongation";

export function BookingRoutes() {
	return (
		<BookingContextProvider>
			<BookingShell />
		</BookingContextProvider>
	)
}

function BookingShell() {
	const {view} = useParams<{ view: string }>();
	const {booking} = useBooking();

	const simplifiedLayout = useMemo(() =>
			booking?.site !== undefined && hasSimplifiedLayout(booking.site)
		, [booking?.site]);

	return (
		<AppLayout
			showBrandingBar={!simplifiedLayout}
		>
			{booking !== undefined && !simplifiedLayout && (
				<>
					{isBlank(view) && (
						<BookingDetails />
					)}
					{view === 'payment' && (
						<BookingPayment />
					)}
					{view === 'boxes' && (
						<BookingBoxes />
					)}
					{view === 'prolong' && (
						<BookingProlongation />
					)}
				</>
			)}
			{booking !== undefined && simplifiedLayout && (
				<>
					{isBlank(view) && (
						<BookingDetailsSimplified />
					)}
					{view === 'payment' && (
						<BookingPayment />
					)}
				</>
			)}
		</AppLayout>
	)
}
